import React from 'react';
import { BRAND, isBrandOV, isMarketGB } from '../../../constants/main';
import { InteriorSelectStyledAC } from './AC/InteriorSelectStyled.AC';
import { InteriorSelectStyledAP } from './AP/InteriorSelectStyled.AP';
import { InteriorSelectStyledDS } from './DS/InteriorSelectStyled.DS';
import { InteriorSelectStyledOV } from './OV/InteriorSelectStyled.OV';
import { InteriorSelectStyledOVGB } from './OV/GB/InteriorSelectStyled.OV.GB';
import { InteriorSelectStyled } from './InteriorSelectStyled';
import { SC } from '../../../styles/theme';

export type InteriorSelectProps = SC & {};

const InteriorSelect = (props: InteriorSelectProps) => {
    if (isBrandOV) return isMarketGB ? <InteriorSelectStyledOVGB {...props} /> : <InteriorSelectStyledOV {...props} />;
    if (BRAND === 'OV') return <InteriorSelectStyledOV {...props} />;
    if (BRAND === 'AC') return <InteriorSelectStyledAC {...props} />;
    if (BRAND === 'AP') return <InteriorSelectStyledAP {...props} />;
    if (BRAND === 'DS') return <InteriorSelectStyledDS {...props} />;
    return <InteriorSelectStyled {...props} />;
};

export default InteriorSelect;
